// TODO (Nick 2026.04.29) - move this decompression logic to the backend so responses arrive already decompressed
import pako from 'pako';

const HEADER_BODY_SEPARATOR = '\r\n\r\n';
const SEPARATOR_BYTES = [0x0d, 0x0a, 0x0d, 0x0a]; // \r\n\r\n
const GZIP_MAGIC = [0x1f, 0x8b];

export default function decompressGzipBody(responseBytes) {
  const separatorIndex = findSequence(responseBytes, SEPARATOR_BYTES);

  if (separatorIndex === -1) {
    return bytesToString(responseBytes);
  }

  const headerBytes = responseBytes.slice(0, separatorIndex);
  const bodyBytes = responseBytes.slice(separatorIndex + SEPARATOR_BYTES.length);
  const headers = bytesToString(headerBytes);

  if (bodyBytes.length < 2 || bodyBytes[0] !== GZIP_MAGIC[0] || bodyBytes[1] !== GZIP_MAGIC[1]) {
    return headers + HEADER_BODY_SEPARATOR + bytesToString(bodyBytes);
  }

  try {
    const decompressed = pako.ungzip(bodyBytes, { to: 'string' });
    return headers + HEADER_BODY_SEPARATOR + decompressed;
  } catch {
    return headers + HEADER_BODY_SEPARATOR + bytesToString(bodyBytes);
  }
}

function bytesToString(bytes) {
  return new TextDecoder('utf-8', { fatal: false }).decode(bytes);
}

function findSequence(haystack, needle) {
  for (let i = 0; i <= haystack.length - needle.length; i++) {
    let found = true;
    for (let j = 0; j < needle.length; j++) {
      if (haystack[i + j] !== needle[j]) {
        found = false;
        break;
      }
    }
    if (found) {
      return i;
    }
  }
  return -1;
}
